var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-content"},[_c('div',{staticClass:"account-content__wrapper",class:_vm.params.transparent ? 'account-content__transparent' : 'account-content__white'},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }